<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        {{ viewModel.isEdit ? 'Редактирование претензии' : 'Добавление претензии' }}
        <v-spacer />
        <span v-if="viewModel.isReadOnly" class="caption grey--text">(Только просмотр)</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <!-- Информация о товаре -->
          <v-row>
            <v-col cols="6">
              <v-text-field v-model="viewModel.goodArticle" label="Артикул" readonly dense />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="viewModel.goodName" label="Наименование" readonly dense />
            </v-col>
          </v-row>

          <!-- Количество с валидацией -->
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="claim.qty" label="Количество (упаковок)" type="number" :min="0"
                :max="viewModel.maxQty" :readonly="viewModel.isReadOnly" :disabled="viewModel.isReadOnly"
                :error-messages="qtyErrors" @input="validateQty" @blur="validateQty" suffix="уп." />
              <div class="caption grey--text">
                Максимальное количество: {{ viewModel.maxQty }} упаковок
              </div>
            </v-col>
          </v-row>

          <!-- Цена -->
          <v-row>
            <v-col cols="12">
              <v-text-field v-model="claim.unitPrice" label="Цена за упаковку" type="number" :min="0" :step="0.01"
                :readonly="viewModel.isReadOnly" :disabled="viewModel.isReadOnly" prefix="₽" />
            </v-col>
          </v-row>

          <!-- Комментарий -->
          <v-row>
            <v-col cols="12">
              <v-textarea v-model="claim.description" label="Комментарий" :readonly="viewModel.isReadOnly"
                :disabled="viewModel.isReadOnly" rows="3" />
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-btn text @click="close">Закрыть</v-btn>
        <v-btn v-if="!viewModel.isReadOnly" color="primary" :loading="saving" :disabled="!isValid" @click="save">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    saving: false,
    claim: {
      qty: 0,
      unitPrice: null,
      description: ''
    },
    qtyErrors: []
  }),

  props: {
    value: {
      type: Object,
      default: null
    },
    saveCallback: {
      type: Function,
      required: true
    }
  },

  computed: {
    viewModel() {
      return this.value || {}
    },

    isValid() {
      return this.claim.qty > 0 &&
        this.claim.qty <= this.viewModel.maxQty &&
        this.claim.unitPrice !== null &&
        this.claim.unitPrice > 0 &&
        this.qtyErrors.length === 0
    }
  },

  watch: {
    value: {
      handler(newVal) {
        if (newVal) {
          this.dialog = true
          this.claim = {
            qty: newVal.qty || 0,
            unitPrice: newVal.unitPrice || null,
            description: newVal.description || ''
          }
          this.validateQty()
        } else {
          this.dialog = false
        }
      },
      immediate: true
    }
  },

  methods: {
    validateQty() {
      this.qtyErrors = []

      if (this.claim.qty === null || this.claim.qty === undefined || this.claim.qty === '') {
        this.qtyErrors.push('Введите количество')
        return
      }

      const qty = Number(this.claim.qty)

      if (isNaN(qty) || qty <= 0) {
        this.qtyErrors.push('Количество должно быть больше 0')
        return
      }

      if (qty > this.viewModel.maxQty) {
        this.qtyErrors.push(`Количество не может превышать ${this.viewModel.maxQty} упаковок`)
        return
      }

      // Проверка на дробные значения (если нужно целое количество упаковок)
      if (!Number.isInteger(qty)) {
        this.qtyErrors.push('Количество должно быть целым числом')
        return
      }
    },

    async save() {
      if (!this.isValid) {
        this.validateQty()
        return
      }

      this.saving = true
      try {
        const result = await this.saveCallback({
          ...this.viewModel,
          qty: Number(this.claim.qty),
          unitPrice: Number(this.claim.unitPrice),
          description: this.claim.description
        })

        if (result !== false) {
          this.close()
        }
      } finally {
        this.saving = false
      }
    },

    close() {
      this.dialog = false
      this.$emit('input', null)
    }
  }
}
</script>